import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlignCenterRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 3,
		y: 5,
		width: 18,
		height: 14,
		rx: 1,
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("rect", {
		x: 15.0005,
		y: 9,
		width: 6,
		height: 6,
		fill: "currentColor"
	})]
});
export default SvgAlignCenterRight;
